import { render, staticRenderFns } from "./DriverBalanceStatistics.vue?vue&type=template&id=838ebc28&"
import script from "./DriverBalanceStatistics.vue?vue&type=script&lang=js&"
export * from "./DriverBalanceStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports